import React, { PropsWithChildren, HTMLAttributes } from 'react';

import styles from './CellWithInputPadding.module.css';

export type CellWithInputPaddingProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

/*
  Компонент для использования внутри функции render для колонки таблицы antd.
  Задает отступы как внутри Input antd.
  Решает проблему "прыгающего" текста при переключении таблицы в режим редактирования.
 */
export const CellWithInputPadding = ({ children, ...rest }: CellWithInputPaddingProps) => {
  return (
    <div className={styles.tableCellWrapper} {...rest}>
      {children || '–'}
    </div>
  );
};
